//Libraries
import React, { Component } from 'react';

import { Badge, 
    Input, InputGroup, InputGroupAddon, InputGroupText,
 } from 'reactstrap';


class QueryableAreaComponent extends Component {


  render() {
        return(
            <div>
                {this.props.children}
            </div>
        )
    }
}


export default QueryableAreaComponent